import _ from 'lodash'
import * as queryString from 'query-string'
import { Dictionary } from './types/utility'
import { isNotEmptyElement } from './array'

export function getQueryStringParams(url: string): queryString.ParsedQuery {
  if (!url) {
    return {}
  }

  return queryString.parseUrl(url).query
}

export function stripQueryStringParamFromUrl(
  url: string,
  param: string,
  caseSensitive = false
): string {
  if (!url) {
    return url
  }

  return queryString.exclude(
    url, // I <3 PRETTIER
    key => {
      return caseSensitive
        ? key === param // I <3 PRETTIER
        : key.toLowerCase() === param.toLowerCase()
    }
  )
}

export function pickQueryStringParamValueFromUrl(
  url: string,
  param: string,
  caseSensitive = false
): string[] {
  const allQueryStringParams = getQueryStringParams(url)

  const targetedQueryStringParams = _.pickBy(
    allQueryStringParams, // I <3 PRETTIER
    (value, key) => {
      return caseSensitive
        ? key === param // I <3 PRETTIER
        : key.toLowerCase() === param.toLowerCase()
    }
  )

  return Object.values(targetedQueryStringParams).flat().filter(isNotEmptyElement)
}

export function stripQueryStringFromUrl(url: string): string {
  if (!url) {
    return url
  }

  return queryString.parseUrl(url).url
}

export function isValidUrl(url: string): boolean | undefined {
  try {
    return Boolean(new URL(url))
  } catch {
    return false
  }
}

export const appendQueryParamsToUrl = (url: string, params: Dictionary<string, any>): string => {
  const parsed = queryString.parseUrl(url)

  return queryString.stringifyUrl({
    url: parsed.url,
    query: { ...parsed.query, ...params }
  })
}
